var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUniversityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#CAEB00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "url(#paint0_linear_664_12602)",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 51,
    height: 51,
    rx: 25.5,
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 19H36V24H37V19Z",
    fill: "#000204"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 32H35V36H18V32Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 26H35V29H21V26Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 31.5H21C19.6193 31.5 18.5 32.6193 18.5 34V34C18.5 35.3807 19.6193 36.5 21 36.5H35.5",
    stroke: "#0099EF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26H33.5C34.3284 26 35 26.6716 35 27.5V27.5C35 28.3284 34.3284 29 33.5 29H20",
    stroke: "#8627FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19C16 18.4477 16.4477 18 17 18H37C37.5523 18 38 18.4477 38 19C38 19.5523 37.5523 20 37 20H17C16.4477 20 16 19.5523 16 19Z",
    fill: "#000204"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20C21 19.4477 21.4477 19 22 19H32C32.5523 19 33 19.4477 33 20V24C33 24.5523 32.5523 25 32 25H22C21.4477 25 21 24.5523 21 24V20Z",
    fill: "#000204"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 23,
    width: 3,
    height: 3,
    rx: 1.5,
    fill: "#FF2F13"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_664_12602",
    x1: 15.5,
    y1: 7.5,
    x2: 43.5,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFFF20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902985,
    stopColor: "#00BD00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityIcon);
export default __webpack_public_path__ + "static/media/university-icon.848f2444d2216b312f9bcf1f5113a5a3.svg";
export { ForwardRef as ReactComponent };